import React, { useEffect, useState } from "react";
import { API_BASE } from "../config";

export default function FpoSelector() {
  const role = localStorage.getItem("role") || "fpo_admin";
  const token = localStorage.getItem("token");

  const [fpos, setFpos] = useState([]);
  const [selectedFpoId, setSelectedFpoId] = useState(
    localStorage.getItem("selected_fpo_id") ||
      localStorage.getItem("fpo_id") ||
      "1"
  );

  useEffect(() => {
    if (role !== "super_admin") return;

    const loadFpos = async () => {
      try {
        const res = await fetch(`${API_BASE}/fpos`, {
          headers: { Authorization: token },
        });

        const data = await res.json();

        if (res.ok && data.success !== false) {
          const list = Array.isArray(data.data) ? data.data : [];
          setFpos(list);

          if (!localStorage.getItem("selected_fpo_id") && list.length > 0) {
            const first = list[0];
            const firstId = String(first.id);

            localStorage.setItem("selected_fpo_id", firstId);
            localStorage.setItem("selected_fpo_name", first.name || "");
            setSelectedFpoId(firstId);
          } else {
            const selected = list.find(
              (f) => String(f.id) === String(selectedFpoId)
            );

            if (selected) {
              localStorage.setItem("selected_fpo_name", selected.name || "");
            }
          }
        }
      } catch (err) {
        console.error("FPO selector load error:", err);
      }
    };

    loadFpos();
  }, [role, token, selectedFpoId]);

  if (role !== "super_admin") return null;

  const handleChange = (e) => {
    const value = e.target.value;
    const selected = fpos.find((f) => String(f.id) === String(value));

    localStorage.setItem("selected_fpo_id", value);
    localStorage.setItem("selected_fpo_name", selected?.name || "");

    setSelectedFpoId(value);
    window.location.reload();
  };

  return (
    <div className="fpo-selector-box">
      <div className="fpo-selector-label">Viewing FPO</div>

      <select
        value={selectedFpoId}
        onChange={handleChange}
        title={
          fpos.find((f) => String(f.id) === String(selectedFpoId))?.name || ""
        }
        className="fpo-selector-select"
      >
        {fpos.map((fpo) => (
          <option key={fpo.id} value={fpo.id}>
            {fpo.name.length > 22
              ? `${fpo.name.substring(0, 22)}... #${fpo.id}`
              : `${fpo.name} #${fpo.id}`}
          </option>
        ))}
      </select>
    </div>
  );
}